export default {
  selected: false
}
